import React, { useState, useEffect } from "react";
import { Card, Row, Col, Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";

export default function Settings() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [passwords, setPasswords] = useState({
        ancien_mdp: '',
        nouveau_mdp: '',
        confirmation: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPasswords(prev => ({ ...prev, [name]: value }));
    };

    const getToken = () => localStorage.getItem("token");

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (passwords.nouveau_mdp !== passwords.confirmation) {
            setError("Les mots de passe ne correspondent pas");
            return;
        }

        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const token = getToken();
            
            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/utilisateurs.php?action=password',
                {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ancien_mdp: passwords.ancien_mdp,
                        nouveau_mdp: passwords.nouveau_mdp
                    })
                }
            );
            
            if (!response.ok) {
                throw new Error(`Erreur HTTP: ${response.status}`);
            }
            
            const result = await response.json();
            
            if (result.success) {
                setSuccess(true);
                setPasswords({
                    ancien_mdp: '',
                    nouveau_mdp: '',
                    confirmation: ''
                });
                setTimeout(() => setSuccess(false), 3000);
            } else {
                setError(result.message);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="container-fluid">
                    <h1 className="page-title mb-4">
                        <i className="ri-user-settings-line me-2"></i>
                        Paramètres du compte
                    </h1>

                    <Row>
                        <Col lg={6}>
                            <Card className="border-0 shadow-sm mb-4">
                                <Card.Header className="bg-white border-0 pt-4">
                                    <h5 className="mb-0">
                                        <i className="ri-lock-password-line me-2"></i>
                                        Changer le mot de passe
                                    </h5>
                                </Card.Header>
                                <Card.Body>
                                    {error && (
                                        <Alert variant="danger">
                                            <i className="ri-error-warning-line me-2"></i>
                                            {error}
                                        </Alert>
                                    )}
                                    
                                    {success && (
                                        <Alert variant="success">
                                            <i className="ri-checkbox-circle-line me-2"></i>
                                            Mot de passe modifié avec succès !
                                        </Alert>
                                    )}

                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Ancien mot de passe</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="ancien_mdp"
                                                value={passwords.ancien_mdp}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Nouveau mot de passe</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="nouveau_mdp"
                                                value={passwords.nouveau_mdp}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-4">
                                            <Form.Label>Confirmer le mot de passe</Form.Label>
                                            <Form.Control
                                                type="password"
                                                name="confirmation"
                                                value={passwords.confirmation}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>

                                        <Button 
                                            type="submit" 
                                            variant="primary"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <Spinner size="sm" className="me-2" />
                                                    Modification...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="ri-save-line me-2"></i>
                                                    Changer le mot de passe
                                                </>
                                            )}
                                        </Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg={6}>
                            <Card className="border-0 shadow-sm mb-4">
                                <Card.Header className="bg-white border-0 pt-4">
                                    <h5 className="mb-0">
                                        <i className="ri-notification-line me-2"></i>
                                        Préférences de notification
                                    </h5>
                                </Card.Header>
                                <Card.Body>
                                    <Form>
                                        <div className="mb-3">
                                            <Form.Check 
                                                type="switch"
                                                id="email-notif"
                                                label="Notifications par email"
                                                defaultChecked
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <Form.Check 
                                                type="switch"
                                                id="stock-alert"
                                                label="Alertes de stock bas"
                                                defaultChecked
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <Form.Check 
                                                type="switch"
                                                id="commandes-alert"
                                                label="Nouvelles commandes"
                                                defaultChecked
                                            />
                                        </div>
                                    </Form>
                                </Card.Body>
                            </Card>

                            <Card className="border-0 shadow-sm">
                                <Card.Header className="bg-white border-0 pt-4">
                                    <h5 className="mb-0">
                                        <i className="ri-palette-line me-2"></i>
                                        Apparence
                                    </h5>
                                </Card.Header>
                                <Card.Body>
                                    <Form>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Thème</Form.Label>
                                            <Form.Select>
                                                <option value="light">Clair</option>
                                                <option value="dark">Sombre</option>
                                                <option value="auto">Automatique</option>
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Label>Langue</Form.Label>
                                            <Form.Select>
                                                <option value="fr">Français</option>
                                                <option value="en">English</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <Footer />
            </div>
        </>
    );
}